var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25732 1.98688C5.28343 1.89182 5.23059 1.79229 5.13953 1.76503C5.04847 1.73777 4.95314 1.79294 4.92703 1.88801L4.643 1.80298C4.71402 1.5444 4.9733 1.39436 5.22097 1.4685C5.46864 1.54265 5.61236 1.81334 5.54134 2.07191C5.48455 2.27869 5.30735 2.41607 5.11199 2.42489L5.06074 2.61147L4.77671 2.52644L4.90281 2.06734L5.04482 2.10986C5.13588 2.13712 5.23121 2.08195 5.25732 1.98688Z",
    fill: "#B4C1E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73477 2.69036L5.0188 2.77539L4.93735 3.07192L4.65332 2.98689L4.73477 2.69036Z",
    fill: "#B4C1E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80814 -0.0078125L7.16985 0.998581L6.2059 4.50829L2.84418 3.5019L3.80814 -0.0078125ZM4.10786 0.556701L6.62914 1.3115L5.90618 3.94378L3.38489 3.18898L4.10786 0.556701Z",
    fill: "#B4C1E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75875 6.66233C3.78013 6.53576 3.69889 6.41464 3.57766 6.39232C3.45643 6.37 3.34041 6.45482 3.31903 6.58138L2.94089 6.51177C2.99904 6.16752 3.3146 5.93683 3.64433 5.99753C3.97407 6.05824 4.19503 6.38769 4.13689 6.73194C4.09039 7.00724 3.87926 7.2099 3.62792 7.24901L3.58596 7.49742L3.20783 7.42781L3.31106 6.81659L3.50012 6.8514C3.62135 6.87372 3.73738 6.7889 3.75875 6.66233Z",
    fill: "#B4C1E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17501 7.6463L3.55314 7.71591L3.48647 8.11069L3.10833 8.04108L3.17501 7.6463Z",
    fill: "#B4C1E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15753 3.89616L4.30701 4.78121L1.62705 4.28786L0.837891 8.96046L5.14682 9.75369L5.26146 10.4324L12.4952 9.10077L11.2197 1.54853L6.79541 2.363L6.57197 3.17653L10.6287 2.42972L11.6512 8.48376L5.85245 9.55125L4.93675 4.12943L4.15753 3.89616ZM2.09985 4.99281L4.41472 5.41895L4.93681 8.51019L4.84067 9.07942L1.51311 8.46685L2.09985 4.99281Z",
    fill: "#B4C1E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48095 5.25392C8.4464 5.04935 8.25888 4.91227 8.06294 4.94834C7.867 4.98441 7.73569 5.18019 7.77024 5.38476L7.15907 5.49727C7.0651 4.94086 7.42223 4.40837 7.95517 4.31026C8.48811 4.21215 8.99815 4.58501 9.09213 5.14141C9.16728 5.58637 8.95391 6.01603 8.59288 6.22048L8.66069 6.62198L8.04952 6.73449L7.88267 5.7466L8.18826 5.69034C8.3842 5.65427 8.5155 5.45849 8.48095 5.25392Z",
    fill: "#B4C1E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11503 7.08473L8.7262 6.97222L8.83397 7.6103L8.22279 7.72281L8.11503 7.08473Z",
    fill: "#B4C1E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/lesson.1ab2abcc158429eb687f24166b272b78.svg";
export { ForwardRef as ReactComponent };